import { render, staticRenderFns } from "./defaultDetails.vue?vue&type=template&id=d938040a&scoped=true"
import script from "./defaultDetails.vue?vue&type=script&lang=js"
export * from "./defaultDetails.vue?vue&type=script&lang=js"
import style0 from "./defaultDetails.vue?vue&type=style&index=0&id=d938040a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d938040a",
  null
  
)

export default component.exports